module.exports = __webpack_public_path__ + "img/shop_pc_tab_01.902e499c.png";